import {
  Button,
  Col,
  ConfigProvider,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
} from 'antd'
import React, { useEffect, useState } from 'react'

import dayjs from 'dayjs'
import { useRecoilState } from 'recoil'
import Swal from 'sweetalert2'
import inquiryApi from '../../api/inquiry.api'
import ReviewDetailComponent from '../../components/inquiry/ReviewDetailComponent'
import ReviewExcelUpload from '../../components/inquiry/ReviewExcelUpload'
import ContentHeader from '../../components/shared/ContentHeader'
import { userState } from '../../store/user'
import { CustomDateButtonRadioTheme } from '../../styles/CustomAntdTheme'
import styles from '../../styles/inquiry.module.scss'

const ReviewListPage = () => {
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)

  const [dateType, setDateType] = useState('1week')
  const [searchOptions, setSearchOptions] = useState({
    startDate: dayjs().subtract(7, 'days').startOf('day'),
    endDate: dayjs().endOf('day'),
    reviewStatus: 'total',
    reviewGrade: 0,
    benefitPayment: 'total',
    exposureStatus: 'total',
    bestReview: 'total',
    searchType: 'product',
    searchText: '',
  })
  const [orderType, setOrderType] = useState('createdAt')
  const [orderBy, setOrderBy] = useState('desc')
  const [totalSize, setTotalSize] = useState(0)
  const [currentPageNumber, setCurrentPageNumber] = useState(1)
  const [offset, setOffset] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [reviewList, setReviewList] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [selectedRows, setSelectedRows] = useState([])

  const [reviewModalShow, setReviewModalShow] = useState(false)

  const [reviewDetailModalShow, setReviewDetailModalShow] = useState(false)
  const [currentReviewId, setCurrentReviewId] = useState(0)
  const [reviewImgQuantity, setReviewImgQuantity] = useState(0)

  const [imageList, setImageList] = useState([])

  const dateTypeItems = [
    { label: '오늘', value: 'today' },
    { label: '1주일', value: '1week' },
    { label: '1개월', value: '1month' },
    { label: '3개월', value: '3month' },
    { label: '6개월', value: '6month' },
    { label: '1년', value: '1year' },
  ]
  const reviewStatusItems = [
    { label: '전체', value: 'total' },
    { label: '포토리뷰', value: 'photo' },
    { label: '텍스트리뷰', value: 'text' },
  ]
  const reviewGradeItems = [
    { label: '전체', value: 0 },
    { label: '1점', value: 1 },
    { label: '2점', value: 2 },
    { label: '3점', value: 3 },
    { label: '4점', value: 4 },
    { label: '5점', value: 5 },
  ]
  const benefitPaymentItems = [
    { label: '전체', value: 'total' },
    { label: '지급완료', value: 'true' },
    { label: '미지급', value: 'false' },
  ]
  const exposureStatusItems = [
    { label: '전체', value: 'total' },
    { label: '정상', value: 'true' },
    { label: '미노출', value: 'false' },
  ]
  const bestReviewItems = [
    { label: '전체', value: 'total' },
    { label: '베스트Y', value: 'true' },
    { label: '베스트N', value: 'false' },
  ]
  const searchTypeItems = [
    { searchType: 'product', searchText: '상품명' },
    { searchType: 'product_id', searchText: '상품번호' },
    { searchType: 'order_id', searchText: '상품주문번호' },
    { searchType: 'review_body', searchText: '내용' },
  ]
  const orderPair = {
    order_id: '상품주문번호순',
    review_score: '평점순',
    created_at: '리뷰등록일순',
    updated_at: '최종수정일순',
    review_private: '전시상태순',
    review_report: '신고여부순',
    review_point: '혜택지급순',
    is_best: '베스트리뷰순',
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys)
      setSelectedRows(selectedRows)
    },
  }

  const columns = [
    {
      title: '상품번호',
      // width: 120,
      dataIndex: 'productId',
      key: 'productId',
      fixed: 'left',
      align: 'center',
      ellipsis: true,
      // sorter: (a, b) => {},
    },
    {
      title: '상품주문번호',
      // width: 120,
      dataIndex: 'orderId',
      key: 'orderId',
      align: 'center',
      ellipsis: true,
      // sorter: (a, b) => {},
    },
    {
      title: '상품명',
      width: 120,
      dataIndex: 'productName',
      key: 'productName',
      ellipsis: true,
    },
    {
      title: '평점',
      // width: 120,
      dataIndex: 'reviewScore',
      key: 'reviewScore',
      ellipsis: true,
      align: 'center',
      sorter: (a, b) => {},
      render: (value, record) => {
        let scoreList = []
        for (let i = 0; i < value; i++) {
          scoreList.push(
            <img
              key={`star_${record.id}_${i + 1}`}
              className={`${styles['review-score-img']}`}
              src={`${process.env.REACT_APP_HOST}/assets/icon/inquiry/selectGrade.png`}
            />,
          )
        }
        if (value !== 5) {
          for (let i = 0; i < 5 - value; i++) {
            scoreList.push(
              <img
                key={`star${i + 1}`}
                className={`${styles['review-score-img']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/inquiry/unSelectGrade.png`}
              />,
            )
          }
        }
        return (
          <>
            <Row align="middle" wrap={false}>
              {scoreList.map((score) => score)}
            </Row>
            <span className={`${styles['review-score-text']}`}>{value}점</span>
          </>
        )
      },
    },
    {
      title: '포토',
      // width: 120,
      dataIndex: 'reviewImgQuantity',
      key: 'reviewImgQuantity',
      ellipsis: true,
      align: 'center',
      onCell: (value, record) => {
        return {
          onClick: (e) => {
            e.stopPropagation()
            setCurrentReviewId(value.id)
            setReviewDetailModalShow(true)
            setReviewImgQuantity(value.reviewImgQuantity)
            setImageList(value?.reviewImgList || [])
          },
        }
      },
      render: (value, record) => {
        if (
          value !== 0 &&
          record?.reviewImgList &&
          record.reviewImgList.length > 0
        ) {
          return (
            <img
              className="review-main-img"
              style={{
                width: '120px',
                height: '120px',
                objectFit: 'cover',
              }}
              src={`${process.env.REACT_APP_S3_HOST}/${record.reviewImgList[0].imgName}`}
              alt={`review main img`}
            />
          )
        } else {
          return '없음'
        }
      },
    },
    {
      title: '리뷰내용',
      width: 180,
      dataIndex: 'reviewBody',
      key: 'reviewBody',
      // ellipsis: true,
      onCell: (value, record) => {
        return {
          onClick: (e) => {
            e.stopPropagation()
            setCurrentReviewId(value.id)
            setReviewDetailModalShow(true)
          },
        }
      },
      render: (value) => {
        return <span>{value}</span>
      },
    },
    {
      title: '전시상태',
      // width: 120,
      dataIndex: 'reviewPrivate',
      key: 'reviewPrivate',
      ellipsis: true,
      align: 'center',
      sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return '정상'
        } else {
          return '미노출'
        }
      },
    },
    {
      title: '베스트여부',
      // width: 120,
      dataIndex: 'isBest',
      key: 'isBest',
      ellipsis: true,
      align: 'center',
      sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return 'Y'
        } else {
          return 'N'
        }
      },
    },
    {
      title: '신고여부',
      // width: 120,
      dataIndex: 'reviewReport',
      key: 'reviewReport',
      ellipsis: true,
      align: 'center',
      // sorter: (a, b) => {},
      render: (value, record) => {
        if (value) {
          return (
            <>
              <p>Y</p>
              <p>({dayjs(record.reviewReportDate).format('YYYY.MM.DD')})</p>
            </>
          )
        } else {
          return 'N'
        }
      },
    },
    {
      title: '혜택지급',
      // width: 120,
      dataIndex: 'reviewPoint',
      key: 'reviewPoint',
      ellipsis: true,
      align: 'center',
      render: (value) => {
        if (value !== null) {
          return (
            <>
              <p>Y</p>
              <p>({value}P)</p>
            </>
          )
        } else {
          return 'N'
        }
      },
    },
    {
      title: '등록자(userId)',
      // width: 120,
      dataIndex: 'createdBy',
      key: 'createdBy',
      ellipsis: true,
      align: 'left',
    },
    {
      title: '리뷰등록일',
      // width: 150,
      dataIndex: 'createdAt',
      key: 'createdAt',
      ellipsis: true,
      align: 'center',
      sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return (
            <>
              <p>{dayjs(value).format('YYYY.MM.DD')}</p>
              <p>{dayjs(value).format('HH:mm:ss')}</p>
            </>
          )
        }
      },
    },
    {
      title: '최종수정일',
      // width: 180,
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      ellipsis: true,
      align: 'center',
      // sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return (
            <>
              <p>{dayjs(value).format('YYYY.MM.DD')}</p>
              <p>{dayjs(value).format('HH:mm:ss')}</p>
            </>
          )
        }
      },
    },
  ]

  useEffect(() => {
    getReadReviews('initial')
    // getReviewList()
  }, [])

  useEffect(() => {
    getReadReviews()
  }, [offset, pageSize, orderType, orderBy])

  //res.data.code
  const getReadReviews = async (type = '') => {
    setIsLoading(true)
    try {
      let param
      if (type === 'initial') {
        param = {
          offset: 0,
          pageSize: 10,
          startDate: dayjs()
            .subtract(7, 'days')
            .startOf('day')
            .format('YYYY-MM-DD'),
          endDate: dayjs().endOf('day').format('YYYY-MM-DD'),
          reviewStatus: reviewStatusItems[0].value,
          reviewGrade: reviewGradeItems[0].value,
          benefitPayment: benefitPaymentItems[0].value,
          exposureStatus: exposureStatusItems[0].value,
          bestReview: bestReviewItems[0].value,
          searchType: searchTypeItems[0].searchType,
          searchText: '',
          orderType: 'created_at',
          orderBy: 'desc',
        }
      } else if (type === 'search') {
        param = {
          offset: 0,
          pageSize: 10,
          ...searchOptions,
          startDate: searchOptions.startDate.format('YYYY-MM-DD'),
          endDate: searchOptions.endDate.format('YYYY-MM-DD'),
          orderType: orderType,
          orderBy: orderBy,
        }
      } else {
        param = {
          offset: offset,
          pageSize: pageSize,
          ...searchOptions,
          startDate: searchOptions.startDate.format('YYYY-MM-DD'),
          endDate: searchOptions.endDate.format('YYYY-MM-DD'),
          orderType: orderType,
          orderBy: orderBy,
        }
      }
      const res = await inquiryApi.readReviewList(param, user.id)
      if (res.data.code === 200) {
        setReviewList(res.data.result.reviewList)
        setTotalSize(res.data.result.totalCnt)
      } else {
        alert(
          '리뷰 목록을 조회해오지 못하였습니다. 다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.',
        )
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('getReadReviews read error', error)
    }
  }

  /**
   * 표출/미표출여부 수정 버튼 click
   */
  // const handleEditBtnClick = async () => {
  //   setIsLoading(true)
  //   try {
  //     let newEditReview = {
  //       editList: selectedRowKeys,
  //       editKey: 'review_private',
  //       editor: user.user_id,
  //     }
  //     const res = await inquiryApi.editReview(newEditReview, user.id)
  //     if (res.data.code === 200) {
  //       alert('해당 내용이 성공적으로 수정되었습니다.')
  //       getReadReviews()
  //       setSelectedRowKeys([])
  //       setSelectedRows([])
  //     } else if (res.data.code === 999) {
  //       alert(res.data.msg)
  //     } else {
  //       alert('정상적인 요청이 아닙니다.')
  //     }
  //     setIsLoading(false)
  //   } catch (error) {
  //     setIsLoading(false)
  //     console.log('handleEditBtnClick edit error', error)
  //   }
  // }

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value
    setDateType(value)
    switch (value) {
      case 'today':
        setSearchOptions({
          ...searchOptions,
          startDate: dayjs().startOf('day'),
          endDate: dayjs().endOf('day'),
        })
        break
      case '1week':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(7, 'days').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(7, 'days')
              .startOf('day'),
          })
        }
        break
      case '1month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(1, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(1, 'months')
              .startOf('day'),
          })
        }
        break
      case '3month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(3, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(3, 'months')
              .startOf('day'),
          })
        }
        break
      case '6month':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(6, 'months').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(6, 'months')
              .startOf('day'),
          })
        }
        break
      case '1year':
        if (searchOptions.endDate === null || searchOptions.endDate === '') {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs().subtract(1, 'year').startOf('day'),
            endDate: dayjs().endOf('day'),
          })
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: dayjs(searchOptions.endDate.format('YYYY/MM/DD'))
              .subtract(1, 'year')
              .startOf('day'),
          })
        }
        break
    }
  }

  /**
   * 검색
   */
  const handleSearch = () => {
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert('조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.')
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          '조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.',
        )
      } else {
        setOffset(0)
        setPageSize(10)
        setCurrentPageNumber(1)
        getReadReviews('search')
      }
    }
  }

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setDateType(dateTypeItems[1].value)
    setSearchOptions({
      startDate: dayjs().subtract(7, 'days').startOf('day'),
      endDate: dayjs().endOf('day'),
      reviewStatus: reviewStatusItems[0].value,
      reviewGrade: reviewGradeItems[0].value,
      benefitPayment: benefitPaymentItems[0].value,
      exposureStatus: exposureStatusItems[0].value,
      bestReview: bestReviewItems[0].value,
      searchType: searchTypeItems[0].searchType,
      searchText: '',
    })
    setOffset(0)
    setPageSize(10)
    setCurrentPageNumber(1)
    getReadReviews('initial')
  }

  const tableOnChange = (pagination, filters, sorter) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === 'descend') {
          setOrderBy('desc')
        } else if (sorter.order === 'ascend') {
          setOrderBy('asc')
        }
        setOrderType(sorter.field)
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType('createdAt')
        setOrderBy('desc')
      }
    }
  }

  /**
   * handleRowEvent
   */
  const handleRowEvent = (record) => {
    return {
      onClick: () => {
        let editRowKeys = []
        let editRows = []
        if (selectedRowKeys.includes(record.id)) {
          editRowKeys = selectedRowKeys.filter((key) => key !== record.id)
          editRows = selectedRows.filter((row) => row.id !== record.id)
        } else {
          editRowKeys = [...selectedRowKeys, record.id]
          editRows = [...selectedRows, record]
        }
        setSelectedRowKeys(editRowKeys)
        setSelectedRows(editRows)
      },
    }
  }

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber, pageSize) => {
    const offset = (pageNumber - 1) * pageSize
    setCurrentPageNumber(pageNumber)
    setOffset(offset)
    setPageSize(pageSize)
  }

  /**
   * 리뷰 목록 - 미노출
   * @returns {Promise<void>}
   */
  const handleReviewNoShow = async () => {
    if (window.confirm('미노출 처리하시겠습니까?')) {
      setIsLoading(true)
      const param = {
        editList: selectedRowKeys,
        editKey: 'review_private',
        editValue: false,
      }
      const res = await inquiryApi.editReview(param, user.id)
      if (res.data.code === 200) {
        alert('정상적으로 수정이 완료 되었습니다.')
        getReadReviews()
        setSelectedRowKeys([])
        setSelectedRows([])
      } else {
        alert(res?.data.msg)
      }
      setIsLoading(false)
    }
  }

  /**
   * 리뷰 목록 - 노출
   * @returns {Promise<void>}
   */
  const handleReviewShow = async () => {
    if (window.confirm('노출 처리하시겠습니까?')) {
      setIsLoading(true)
      const param = {
        editList: selectedRowKeys,
        editKey: 'review_private',
        editValue: true,
      }
      const res = await inquiryApi.editReview(param, user.id)
      if (res.data.code === 200) {
        alert('정상적으로 수정이 완료 되었습니다.')
        getReadReviews()
        setSelectedRowKeys([])
        setSelectedRows([])
      } else {
        alert(res?.data.msg)
      }
      setIsLoading(false)
    }
  }

  /**
   * 리뷰 베스트 선정/해제 버튼 클릭 함수
   * @returns {Promise<void>}
   */
  const handleReviewBest = async () => {
    const bestResult = selectedRows?.every((row) => row.isBest)
    Swal.fire({
      title: bestResult
        ? '선택된 베스트리뷰를 해제하시겠습니까?\n(상품페이지 리뷰 상단에서 노출되지 않게 됩니다.)'
        : '베스트리뷰 선정 시 사진이 첨부되었거나 꼼꼼하게 작성된 리뷰를 선정해주세요.\n(선정된 베스트리뷰는 상품페이지 리뷰 상단에 자동으로 노출됩니다.)',
      customClass: 'custom-alert',
      confirmButtonColor: '#117ffa',
      confirmButtonText: '확인',
    }).then(async ({ isConfirmed }) => {
      if (isConfirmed) {
        setIsLoading(true)
        const param = {
          editList: selectedRowKeys,
          editKey: 'is_best',
          editValue: !bestResult,
        }
        const res = await inquiryApi.editReview(param, user.id)
        if (res.data.code === 200) {
          alert('정상적으로 수정이 완료되었습니다.')
          getReadReviews()
          setSelectedRowKeys([])
          setSelectedRows([])
        } else if (res.data.code === 999) {
          setIsLoading(false)
          alert(res.data.msg)
        } else {
          setIsLoading(false)
          alert(
            '해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.',
          )
        }
      }
    })
  }

  /**
   * 베스트 선정/해제 버튼 disabled 상태값
   * @returns {boolean}
   */
  const disabledBestBtnStatus = () => {
    let result = true
    if (selectedRows.length) {
      const firstValue = selectedRows[0]?.isBest
      result = !selectedRows?.every((row) => row.isBest === firstValue)
    }
    return result
  }
  // useEffect(() => {
  //   console.log('reviewList', reviewList)
  // }, [reviewList])

  return (
    <>
      <ContentHeader title="리뷰 관리" />
      <div
        className={`${styles['product-register-wrap']}`}
        style={{ minWidth: '1024px' }}
      >
        {/*리뷰관리 검색*/}
        <div className={`${styles['product-search-box-wrap']}`}>
          <Form.Item
            className={`${styles['center-label']}`}
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <ConfigProvider theme={CustomDateButtonRadioTheme}>
              <Row align={'middle'} style={{ gap: '5px' }}>
                <Radio.Group
                  className={`${styles['options-list']}`}
                  options={dateTypeItems}
                  onChange={handleDateTypeChange}
                  value={dateType}
                  optionType="button"
                />
                <DatePicker
                  className={`${styles['order-search-date-wrap']}`}
                  format="YYYY/MM/DD"
                  value={searchOptions.startDate}
                  onChange={(value) => {
                    setDateType('')
                    setSearchOptions({ ...searchOptions, startDate: value })
                  }}
                />
                ~
                <DatePicker
                  className={`${styles['order-search-date-wrap']}`}
                  format="YYYY/MM/DD"
                  value={searchOptions.endDate}
                  onChange={(value) => {
                    setDateType('')
                    setSearchOptions({ ...searchOptions, endDate: value })
                  }}
                />
              </Row>
            </ConfigProvider>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="리뷰타입"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              options={reviewStatusItems}
              onChange={(e) =>
                setSearchOptions({
                  ...searchOptions,
                  reviewStatus: e.target.value,
                })
              }
              value={searchOptions.reviewStatus}
            />
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            label="카테고리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle" wrap={false}>
              <Col span={2}>
                <div
                  className={`${styles['review-search-category-content-label']}`}
                >
                  구매자평점
                </div>
              </Col>
              <Radio.Group
                options={reviewGradeItems}
                onChange={(e) =>
                  setSearchOptions({
                    ...searchOptions,
                    reviewGrade: e.target.value,
                  })
                }
                value={searchOptions.reviewGrade}
              />
            </Row>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Row align="middle" wrap={false}>
              <Col span={2}>
                <div
                  className={`${styles['review-search-category-content-label']}`}
                >
                  혜택지급
                </div>
              </Col>
              <Radio.Group
                options={benefitPaymentItems}
                onChange={(e) =>
                  setSearchOptions({
                    ...searchOptions,
                    benefitPayment: e.target.value,
                  })
                }
                value={searchOptions.benefitPayment}
              />
            </Row>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Row align="middle" wrap={false}>
              <Col span={2}>
                <div
                  className={`${styles['review-search-category-content-label']}`}
                >
                  전시상태
                </div>
              </Col>
              <Radio.Group
                options={exposureStatusItems}
                onChange={(e) =>
                  setSearchOptions({
                    ...searchOptions,
                    exposureStatus: e.target.value,
                  })
                }
                value={searchOptions.exposureStatus}
              />
            </Row>
            <Divider
              className={`${styles['product-register-form-input-divider']}`}
            />
            <Row align="middle" wrap={false}>
              <Col span={2}>
                <div
                  className={`${styles['review-search-category-content-label']}`}
                >
                  베스트리뷰
                </div>
              </Col>
              <Radio.Group
                options={bestReviewItems}
                onChange={(e) =>
                  setSearchOptions({
                    ...searchOptions,
                    bestReview: e.target.value,
                  })
                }
                value={searchOptions.bestReview}
              />
            </Row>
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Form.Item
            className={`${styles['center-label']}`}
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 200, textAlign: 'left' }}
            >
              {searchTypeItems.map((item, idx) => (
                <Select.Option
                  key={`search_type_${idx}`}
                  value={item.searchType}
                >
                  {item.searchText}
                </Select.Option>
              ))}
            </Select>
            <Input
              className={`${styles['inquiry-search-input-wrap']}`}
              placeholder="검색어를 입력하세요."
              name="searchText"
              value={searchOptions.searchText}
              onChange={(e) =>
                setSearchOptions({
                  ...searchOptions,
                  [e.target.name]: e.target.value,
                })
              }
              onPressEnter={handleSearch}
            />
          </Form.Item>
          <Divider
            className={`${styles['product-register-form-input-divider']}`}
          />
          <Row
            className={`${styles['review-search-button-wrap']}`}
            justify="center"
          >
            <Button
              className={`${styles['review-search-button']} ${styles.search}`}
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className={`${styles['review-search-button']} ${styles.initial}`}
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*리뷰 목록*/}
        <Row
          className={`${styles['product-register-border-box']}`}
          justify={'space-between'}
          wrap={false}
          style={{ marginTop: 20 }}
        >
          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <span className={`${styles['product-register-box-title']}`}>
              리뷰 목록 (총{' '}
              <span
                className={`${styles['product-register-box-subtitle']}`}
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className={`${styles['product-list-subtitle']}`}>
              {orderPair[orderType]}
            </span>

            <Row
              style={{
                marginLeft: 'auto',
                gap: '0.5em',
              }}
            >
              <Button
                style={{
                  fontSize: '0.9em',
                }}
                danger={
                  selectedRows.length &&
                  selectedRows?.every((row) => row.isBest)
                }
                disabled={disabledBestBtnStatus()}
                onClick={handleReviewBest}
              >
                {selectedRows.length && selectedRows?.every((row) => row.isBest)
                  ? '베스트 해제'
                  : '베스트 선정'}
              </Button>
              <Button
                style={{
                  fontSize: '0.9em',
                }}
                disabled={
                  !selectedRows.length ||
                  selectedRows?.filter((item) => !item.reviewPrivate)?.length
                }
                onClick={handleReviewShow}
              >
                노출
              </Button>
              <Button
                style={{
                  fontSize: '0.9em',
                }}
                disabled={
                  !selectedRows.length ||
                  selectedRows?.filter((item) => item.reviewPrivate)?.length
                }
                onClick={handleReviewNoShow}
              >
                미노출
              </Button>
              <Button
                style={{
                  fontSize: '0.9em',
                }}
                onClick={() => setReviewModalShow(true)}
              >
                <img
                  style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/icon/common/microsoftexcel.png`}
                />
                리뷰 엑셀 업로드
              </Button>
            </Row>
          </div>
        </Row>
        <div
          className={`${styles['product-register-border-box']}`}
          style={{
            borderTop: 0,
            padding: '20px 25px 40px',
            height: 'fit-content',
          }}
        >
          <Table
            className={`${styles['review-table-wrap']}`}
            rowSelection={rowSelection}
            columns={columns}
            dataSource={reviewList}
            loading={isLoading}
            tableLayout={'auto'}
            bordered
            size="middle"
            rowKey="id"
            rowClassName="coupon-table-row"
            scroll={{ x: 'max-content' }}
            onChange={tableOnChange}
            onRow={handleRowEvent}
            pagination={false}
          />

          <Pagination
            showQuickJumper
            showSizeChanger
            total={totalSize}
            pageSize={pageSize}
            current={currentPageNumber}
            onChange={handleChangePagination}
            align={'end'}
            style={{ marginTop: 20 }}
          />
        </div>
      </div>

      {/* 엑셀 일괄 업로드 */}
      {reviewModalShow && (
        <Modal
          className="excel-delivery-modal"
          title="엑셀 일괄 업로드"
          open={reviewModalShow}
          onCancel={() => setReviewModalShow(false)}
          footer={null}
        >
          <ReviewExcelUpload
            setReviewModalShow={setReviewModalShow}
            getReadReviews={getReadReviews}
          />
        </Modal>
      )}

      {/* 리뷰 상세보기 */}
      {reviewDetailModalShow && (
        <ReviewDetailComponent
          reviewDetailModalShow={reviewDetailModalShow}
          setReviewDetailModalShow={setReviewDetailModalShow}
          setImageList={setImageList}
          imageList={imageList}
          // currentReviewId={currentReviewId}
          // reviewList={reviewList}
          searchOptions={searchOptions}
          orderType={orderType}
          orderBy={orderBy}
          getReadReviews={getReadReviews}
          reviewImgQuantity={reviewImgQuantity}
        />
      )}
    </>
  )
}

export default ReviewListPage
